<template>
  <div class="loginContainer">
    <div class="loginContent" @click="showSelect = false">
      <div class="title">{{ $t('lang.messageBox.confirm') }}</div>
      <div class="body">
        <div class="text1">{{hintText}}</div>
        <div class="butons">
          <div class="no-btn" @click="noClick">{{cancelText}}</div>
          <div class="yes-btn" @click="yesClick">{{okText}}</div>
      </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Confirm2',
  props: ['confirmCancel', 'confirmToDo', 'hintText', 'okText', 'cancelText'],
  data () {
    return {
    }
  },
  methods: {
    yesClick () {
      try {
        this.confirmToDo()
      } catch (e) {
      }
      this.$store.state.confirmWinShow = false
    },
    noClick () {
      try {
        this.confirmCancel()
      } catch (e) {
      }
      this.$store.state.confirmWinShow = false
    }
  }
}
</script>

<style lang="less" scoped>
  .loginContainer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.7);
    z-index: 10;
    .loginContent {
      position: absolute;
      top: 50%;
      left: 50%;
      max-width: 600px;
      width: calc(100% - 50px);
      height: 100px;
      transform: translate(-50%,-50%);
      >img {
        position: absolute;
        top: -28px;
        right: -28px;
        width: 28px;
      }
      .title {
        font-size: 24px;
        line-height: 55px;
        font-weight: bold;
        color: #543200;
        text-align: center;
        background: #F6D9AA;
        border-radius: 10px 10px 0 0;
      }
      .body {
        padding: 15px 22px;
        margin-bottom: 40px;
        background: #212324;
        border-radius: 0 0 10px 10px;
        .text1 {
          font-size: 18px;
          line-height: 21px;
          color: #F6D9AA;
        }
        .butons{
          display: flex;
          justify-content:center;
        }
        .yes-btn{
          background: #F6D9AA;
          border-radius: 6px;
          line-height: 20px;
          padding: 12px 0px;
          text-align: center;
          color: #000D2E;
          font-size: 16px;
          margin: 20px 0 0 0;
          width:100px;
          cursor: pointer;
        }
        .no-btn{
          background: #161616;
          border-radius: 6px;
          line-height: 16px;
          padding: 12px 0px;
          text-align: center;
          color: #fff;
          font-size: 16px;
          margin: 20px 10px 0 0;
          width:100px;
          border: 1px solid #F6D9AA;
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ConfirmWin/confirmWithTwoButton.vue